<h4> Support Team </h4>

<app-data-table *ngIf="showDataTable"
                [columns]="tableColumns" [value]="contacts" sortField="name" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                [rightCaptionTemplate]="rightCaptionTemplate" [bodyTemplate]="bodyTemplate">

  <ng-template #rightCaptionTemplate>
    <button pButton (click)="onClickNewContact(contactType)" class="action-secondary" icon="fa fa-plus" label="Support Member"></button>
    <span *ngIf="(contactType === ProjectType.Project) && contractId " style="padding-bottom:3px;">
        <p-multiSelect [options]="contractContacts" [(ngModel)]="selectedContractContacts" styleClass="contacts-multi"></p-multiSelect>
        <span>
          <button pButton type="button" class="action-secondary" icon="fa fa-plus"
                  (click)="onClickAddContractContact(selectedContractContacts)">
          </button>
        </span>
      </span>
  </ng-template>

  <ng-template #bodyTemplate let-row="row" let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span class="p-column-title">{{col.header}}</span>
        <span class="p-cell">
          <div *ngSwitchCase="'contactType'">
            {{row[col.field] | titleCase: NoTitlecaseInternalContactType }}
          </div>
          <div *ngSwitchCase="'action'">
            <button pButton class="icon-action" icon="fa fa-pencil" (click)="onClickEditContact(row)"></button>
            <button pButton class="icon-negative" icon="fa fa-trash" (click)="onClickDeleteContact(row)"></button>
          </div>
          <div *ngSwitchDefault>
            {{row[col.field]}}
          </div>
        </span>
      </td>
    </tr>
  </ng-template>
</app-data-table>

<p-dialog *ngIf="contactToEdit&&displayDialog" header="Support Team" [(visible)]="displayDialog" [responsive]="true" [resizable]="false" [modal]="true"
          [style]="PrimeNgConfig.DialogStyle40">
  <form #dialogForm="ngForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Name*&nbsp;</label>
      </div>
      <div *ngIf="!contactToEdit.id" class="p-col-12 p-md-8 p-lg-8">
        <p-autoComplete name="member" class="autoComplete" field="fullName" appendTo="body" [placeholder]="Validation.AutoCompletePlaceholder"
                        [suggestions]="filteredContacts" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                        (completeMethod)="searchUser($event.query)"
                        [(ngModel)]="selectedContactToAdd"
                        (onSelect)="onSelectContactToAdd(selectedContactToAdd)" required></p-autoComplete>
      </div>
      <div *ngIf="contactToEdit.id" class="p-col-12 p-md-8 p-lg-8">
        {{contactToEdit.fullName}}
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Location*&nbsp;</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown name="location" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [filter]="true"
                    [options]="locationDropdown"
                    [(ngModel)]="contactToEdit.locationId"
                    (onChange)="onChangeLocation()" required></p-dropdown>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label> Contact Type*&nbsp;</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown name="contactType" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                    [options]="contactTypeDropdown"
                    [(ngModel)]="contactToEdit.contactType" required></p-dropdown>
      </div>
    </div>
  </form>

  <p-footer>
    <div class="details" style="text-align:right;margin:10px;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="onClickCancelEdit()"></button>
      <button *ngIf="!contactToEdit.id"
              pButton type="button" icon="fa fa-check" class="button-action" label="Save"
              (click)="onClickAddContact(contactToEdit)"
              [disabled]="!dialogForm.form.valid">
      </button>
      <button *ngIf="contactToEdit.id"
              pButton type="button" class="button-action" icon="fa fa-check" label="Update"
              (click)="onClickUpdateContact(contactToEdit)"
              [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>


<!-- Confirmation dialog for delete -->
<p-confirmDialog key="DeleteInternalContact"></p-confirmDialog>
